// Meta Pixel route tracking is now handled conditionally.
// Only track if user has given advertising consent and fbq is loaded.
exports.onRouteUpdate = function () {
  if (process.env.NODE_ENV === "production" && typeof window !== "undefined" && typeof window.fbq === "function") {
    // Check if advertising consent is given before tracking
    try {
      var stored = localStorage.getItem("cookie_consent_preferences");
      if (stored) {
        var consent = JSON.parse(stored);
        if (consent && consent.advertising) {
          window.fbq("track", "ViewContent");
        }
      }
    } catch (e) {
      // Ignore errors
    }
  }
};
